module.exports = {
    pageNames: {
        '/bcaManager': { pageName:'BCA Manager'},
        '/cardManager': { pageName:'Card Manager'},
        '/cardmember': { pageName:'Card Member'},
        '/accountingManager': { pageName:'Accounting Manager'},
        '/noRole': { pageName:'No Role'},
        '/comments': { pageName:'Comments'},
        '/error': { pageName:'Error'},
        '/transaction-details': { pageName:'Transaction Details'},
        '/allocations': { pageName:'Allocations'},
        '/transactions': { pageName:'Transactions'},
        '/history': { pageName:'History'},
        '/receipts': { pageName:'Receipts'},
        '/merchant-info': { pageName:'Merchant Info'},
        '/preauth-data': { pageName:'Preauth Data'},
        '/meetings360-data': { pageName:'Meeting 360 Data'},
        '/purchase-order-details': { pageName:'Purchase Order Details'},
        '/travel-data': { pageName:'Travel Data'},
        '/btaManager': { pageName:'BTA Manager'},


    },
    tabsNames:{
        transactionTab:{
            'all':{ name : 'All Transactions' },
            'needs-receipt':{ name : 'No Receipts Added' },
            'not-reviewed':{ name : 'Not Reviewed' },
            'needs-submission':{ name : 'Needs Submission' },
            'needs-card-manager-approval':{ name : 'Needs Card Manager Approval' },
            'needs-bca-manager-approval':{ name : 'Needs BCA Manager Approval' },
            'needs-accounting-manager-approval':{ name : 'Needs Accounting Manager Approval' },
            'unlinked':{ name : 'Unlinked' },
            'not-extracted':{ name : 'Not Extracted' },
            'search-results':{ name : 'Search Results' },
            'allocations':{ name : 'Accounting' },
            'transaction-details':{ name : 'Transaction Details' },
            'merchant-info':{ name : 'Merchant Info' },
            'comments':{ name : 'Comments And Additional Data' },
            'history':{ name : 'History' },
            'receipts':{ name : 'Receipts' },
            'preauth-data':{ name : 'Pre Auth Data' },
            'meeting360-details':{ name : 'Meeting 360 Details' },
            'purchase-order-details':{ name : 'PO Details' },
            'travel-data':{ name : 'Travel Data' }
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/modules/angulartics-amex-adobe-analytics/dtmSpecs.js
// module id = 211
// module chunks = 0